import * as React from "react";
import * as S from "@styled";
import { Utilities } from "shared/utilities";
import CustomModal from "shared/components/CustomModal";

export const cookieConsentName = "cookieconsent_status";
const CookiePolicyDialog: React.FC<ICookiePolicyBannerProps> = (props) => {
    const handleDenyCookies = () => {
        Utilities.setCookie(cookieConsentName, "deny", 365, location.hostname, "/")

        // Delete AppInsights tracking cookies
        // Can't use "ai_" as there is also connection string.
        Utilities.deleteCookiesByPrefix("ai_session");
        Utilities.deleteCookiesByPrefix("ai_user");

        // Delete heap cookies
        Utilities.deleteCookiesByPrefix("_hp2_");

        if ((window as any).Intercom) {
            // this should clear all intercom cookies and local storage
            (window as any).Intercom('shutdown');
        }
        // Apparently shutdown does not clear all cookies, so we need to do it manually
        Utilities.deleteCookiesByPrefix("intercom-");

        location.reload();
    }

    const handleAllowCookies = () => {
        Utilities.setCookie(cookieConsentName, "allow", 365, location.hostname, "/")
        location.reload();
    }

    const heapId = document.getElementById("navigationbar")?.getAttribute("data-heap-id");
    const isHeapAvailable = heapId !== "" && heapId !== null;

    return (
        <CustomModal
            label="cookies"
            onClose={() => { }}
            shouldCloseOnOverlayClick={false}
            show={true}
            modalTitle={<h2>Please accept Cookies</h2>}
            size="medium"
            hideCloseButton={true}
        >
            <S.FormGroup>
                <p>
                    We use cookies to improve your experience on the Frends platform.
                    A cookie is a small piece of data we store on your device or browser when you visit the Frends platform.
                    This piece of data allows us to store your user settings, track certain activities you perform on the platform and to personalize your experience by offering for eg. automated on-boarding guidance.
                    For our full Cookie Policy refer to: <a rel="noreferrer" target="_blank" href="https://frends.com/legal/cookie-policy">https://frends.com/legal/cookie-policy</a>.
                </p>
                <span>
                    Frends documentation is available at: <a rel="noreferrer" target="_blank" href="https://docs.frends.com">https://docs.frends.com</a>.
                </span>
            </S.FormGroup>
            <S.FormGroup>
                <p>If you Allow Cookies:</p>
                <ol style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <li>
                        We will be able to offer you personalized on-boarding and guidance experience with real-time support with a 3rd party tool: Intercom (<a rel="noreferrer" target="_blank" href="https://www.intercom.com">https://www.intercom.com/</a>).
                    </li>
                    <li>
                        We use Microsoft Application Insights, a service for collecting, transmitting, storing and analyzing diagnostic and usage data.
                        This helps us understand how our application is performing and where improvements are needed.
                        Application Insights collects data such as response times of requests, failure rates, dependency rates and exceptions.
                        This data is used to monitor the performance and reliability of our application, not to track individual users behavior.
                    </li>
                    {isHeapAvailable && (
                        <li>We will track how you utilize the Frends Platform with a 3rd Party tool: Heap (<a rel="noreferrer" target="_blank" href="https://www.heap.io">https://www.heap.io/</a>).</li>
                    )}
                </ol>
            </S.FormGroup>
            <S.FormGroup>
                <p>You can also at any time choose to revise your Cookie settings under your profile configuration in Frends.</p>
                <b>If you choose to Deny cookies you will NOT RECEIVE any sort of in-application guidance, AI-based instructions, product-tours, how-to videos or other in-product help. We will not track any of your activities if you choose NOT to accept cookies.</b>
            </S.FormGroup>
            <S.ButtonGroup $justifyContentEnd={true}>
                <S.Button variant={S.ButtonType.text} onClick={handleDenyCookies}>
                    Deny
                </S.Button>
                <S.Button variant={S.ButtonType.dark} onClick={handleAllowCookies}>
                    Allow cookies
                </S.Button>
            </S.ButtonGroup>
        </CustomModal>
    )
}

interface ICookiePolicyBannerProps {
    onDecisionCallback: () => void
}

export default CookiePolicyDialog;